module.exports = __webpack_public_path__ + "img/202412_01_sp.25d5d250.jpg";